// Angular 2
import '@angular/platform-browser'
import '@angular/platform-browser-dynamic'
import '@angular/core'
import '@angular/common'
import '@angular/http'
import '@angular/router-deprecated'
// RxJS
import 'rxjs'
// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...

require("./semantic/dist/semantic.min.css")
require("./styles.css")
require("../node_modules/jquery/dist/jquery.min.js")
require("./semantic/dist/semantic.min.js")
//import "node_modules/core-js/client/shim.min.js"
//import "node_modules/zone.js/dist/zone.js"
//import "node_modules/reflect-metadata/Reflect.js"
//import "node_modules/systemjs/dist/system.src.js"


/** WEBPACK FOOTER **
 ** ./src/vendor.ts
 **/